import {ApiConfigurationObj} from './ApiConfigurationObj';
import {ConnectionUserInfoObj} from './ConnectionUserInfoObj';

export class AuthApiConfigurationObj extends ApiConfigurationObj {
kind: string;
token: string;
userInfo: ConnectionUserInfoObj;
}

